module.exports = __webpack_public_path__ + "img/chad-m.1bb74d0b.jpg";